module.exports = __webpack_public_path__ + "img/zsfwct2.30ab1cba.png";